import { render } from "./SubAccounts.vue?vue&type=template&id=08572bdc"
import script from "./SubAccounts.vue?vue&type=script&lang=js"
export * from "./SubAccounts.vue?vue&type=script&lang=js"
script.render = render

export default script